import { useQuery } from '@apollo/client';
import { LenderPerformanceReportInput } from '@trnsact/trnsact-shared-types';
import {
  LenderPerformanceConversionTableQueryResponse,
  LenderPerformanceFunnelQueryResponse,
  LenderPerformanceRatioCardsQueryResponse,
  LenderPerformanceTrendQueryResponse,
} from '../api/types';
import { reportsApi } from '../api';
import { CONVERSION_TABLE_DEFAULT_SORTING } from '../constants';
import { ConversionTableSorting } from '../types';

export const useLenderPerformanceConversionFunnel = (
  input: LenderPerformanceReportInput,
  sorting: ConversionTableSorting = CONVERSION_TABLE_DEFAULT_SORTING
) => {
  const variables = { input };
  const context = { authRequired: true };

  const { data: ratioCardsData, loading: isRatioCardsLoading } = useQuery<LenderPerformanceRatioCardsQueryResponse>(
    reportsApi.getLenderPerformanceRatioCards,
    {
      variables,
      context,
    }
  );

  const { data: funnelData, loading: isFunnelLoading } = useQuery<LenderPerformanceFunnelQueryResponse>(
    reportsApi.getLenderPerformanceFunnel,
    { variables, context }
  );

  const { data: conversionTableData, loading: isConversionTableLoading } =
    useQuery<LenderPerformanceConversionTableQueryResponse>(reportsApi.getLenderPerformanceConversionTable, {
      context,
      variables: { input: { ...input, sorting } },
    });

  const { data: trendData, loading: isTrendLoading } = useQuery<LenderPerformanceTrendQueryResponse>(
    reportsApi.getLenderPerformanceTrend,
    { variables, context }
  );

  return {
    ratioCards: ratioCardsData?.lenderPerformance?.ratioCards?.entity ?? null,
    funnel: funnelData?.lenderPerformance?.funnel?.entity ?? null,
    conversionTable: conversionTableData?.lenderPerformance?.conversionTable?.entity ?? [],
    trend: trendData?.lenderPerformance?.trend?.entity ?? [],
    isRatioCardsLoading,
    isFunnelLoading,
    isConversionTableLoading,
    isTrendLoading,
  };
};
